import styled from 'styled-components';
import { Button, palette } from 'component-library';
import { H6 } from 'components/Text';

export const IconWrapper = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  margin: 0;
`;

export const ModalDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: 0.65fr auto 1fr;
  grid-gap: 2rem;
`;

export const VerticalDivider = styled.div`
  width: 1px;
  background: ${palette.Grey400};
`;

export const ModalButton = styled(Button)`
  font-size: 0.875rem;

  ${({ customStyles }) => {
    return customStyles;
  }}
  &:hover {
    ${({ hoverStyles }) => {
      return hoverStyles;
    }}
  }
`;

export const CardContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  border-radius: 0.5rem;
  box-shadow: 0px 1px 1px 0px rgba(26, 32, 44, 0.08),
    0px 1px 3px 1px rgba(26, 32, 44, 0.16),
    0px -1px 4px 0px rgba(26, 32, 44, 0.05);
  background: ${palette.White};
`;

export const CardHead = styled.div`
  padding: 1.5rem;
  font-weight: 600;
  color: ${palette.Indigo600};
  border-bottom: 1px solid ${palette.Grey300};
`;

export const CardHeader = styled(H6)`
  color: ${palette.Indigo600};
  font-weight: 600;
`;

export const CardBody = styled.div`
  padding: 1.5rem;
`;

export const CardFoot = styled.div`
  padding: 1rem 1.5rem;
  border-top: 1px solid ${palette.Grey300};
`;
